import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "flex h-[calc(100vh-7rem)] bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden"
};
const _hoisted_2 = {
  key: 1,
  class: "flex-1 flex items-center justify-center bg-slate-50/50"
};
import { onMounted } from 'vue';
import { useChatStore } from '@/stores/chat';
import ConversationList from './components/ConversationList.vue';
import ChatArea from './components/ChatArea.vue';
import ChatInfoPanel from './components/ChatInfoPanel.vue';
import NewConversationDialog from './components/NewConversationDialog.vue';
export default {
  __name: 'ChatView',
  setup(__props) {
    const chatStore = useChatStore();
    onMounted(() => {
      chatStore.loadConversations();
      chatStore.loadContacts();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ConversationList), _unref(chatStore).currentConversationId ? (_openBlock(), _createBlock(ChatArea, {
        key: 0
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[0] || (_cache[0] = [_createStaticVNode("<div class=\"text-center\" data-v-2bcf0fe7><div class=\"w-20 h-20 mx-auto mb-4 rounded-full bg-slate-100 flex items-center justify-center\" data-v-2bcf0fe7><svg class=\"w-10 h-10 text-slate-300\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-2bcf0fe7><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z\" data-v-2bcf0fe7></path></svg></div><p class=\"text-slate-500 text-sm\" data-v-2bcf0fe7>选择一个会话开始聊天</p><p class=\"text-slate-400 text-xs mt-1\" data-v-2bcf0fe7>从左侧列表中选择联系人或群组</p></div>", 1)]))])), _createVNode(_Transition, {
        name: "slide-right"
      }, {
        default: _withCtx(() => [_unref(chatStore).showInfoPanel && _unref(chatStore).currentConversation ? (_openBlock(), _createBlock(ChatInfoPanel, {
          key: 0
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(NewConversationDialog)]);
    };
  }
};